































import { exchangeAuthCode } from "../api/auth";
import { NavigationGuardNext, Route } from "vue-router";

import Vue from "vue";
export default Vue.extend({
  name: "Login",
  data() {
    return {
      login: false,
      logout: false,
    };
  },
  methods: {
    setLoginMode(login: boolean) {
      if (login) {
        this.login = true;
        this.logout = false;
      } else {
        this.login = false;
        this.logout = true;
      }
    },
    gotoHomePage() {
      this.$router.push("/");
    },
  },
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
    if (to.meta.isLoginResponse) {
      const code = to.query.code as string;
      const state = to.query.state;
      if (code && state) {
        const storageStateKey = `state-${state}`;
        const storedStateData = localStorage.getItem(storageStateKey);
        if (storedStateData) {
          const decodedStateData = JSON.parse(storedStateData);
          if (decodedStateData.time > new Date().getTime() - 60000) {
            exchangeAuthCode(code).subscribe(
              (response) => {
                console.log(response);
                console.log("Login erfolgreich.");
                next((vm: any) => {
                  vm.$store.dispatch("auth/afterLogin");
                  vm.setLoginMode(true);
                  vm.$parent.updatePrivileges();
                  let nextPage = decodedStateData.url || "/";
                  switch (nextPage) {
                    case "/login":
                    case "/logout":
                    case "/code-response":
                      nextPage = "/";
                  }
                  vm.$router.push(nextPage);
                });
              },
              (reason) => {
                console.error(reason);
                next((vm: any) => {
                  vm.$store.dispatch("auth/afterLogin");
                  vm.setLoginMode(true);
                  vm.$parent.updatePrivileges();
                });
              }
            );
            localStorage.removeItem(storageStateKey);
            return;
          }
        }
        localStorage.removeItem(storageStateKey);
      }
    } else if (to.meta.isLogoutScreen) {
      return next((vm: any) => {
        vm.setLoginMode(false);
        vm.$znaApi.cleanupLocalStorage();
        vm.$parent.updatePrivileges();
        vm.$router.push("/");
      });
    }
    return next((vm) => {
      console.log("Login-State veraltet; leite weiter auf Startseite");
      vm.$router.push("/");
    });
  },
});
